export function hasProSubscription(userSession?: { is_pro_subscription?: boolean } | null): boolean {
  return Boolean(userSession?.is_pro_subscription)
}
